import { purify } from "../_src/components/purify"
import { modalOpenPdfPageflip } from "../acervo-digital"

export function searchNoticiasSearch(dataAction, fieldset, url, contentResult, contentNotFound) {

    let btnLoadMore = document.querySelector(dataAction)

    function search(loadMore) {
        btnLoadMore.classList.add("loading")

        document.querySelectorAll(fieldset).forEach(function(el) {
            el.classList.add("disabled")
        })

        fetch(`${url}/p${btnLoadMore.getAttribute("data-page")}?&loadmore=${loadMore}&Categoria=${btnLoadMore.getAttribute("data-categoria")}&Procurar=${btnLoadMore.getAttribute("data-procurar")}&Instituicao=${btnLoadMore.getAttribute("data-instituicao")}`, {
            method: "POST"
        }).then((response) => {
            return response.text();
        }).then((response) => {

            if (loadMore) {
                document.querySelector(contentResult).insertAdjacentHTML('beforeend', response);

                if (document.querySelector(contentNotFound)) {
                    btnLoadMore.disabled = true
                    document.querySelector(contentNotFound).remove()
                } else {
                    btnLoadMore.disabled = false
                }
            } else {
                document.querySelector(contentResult).innerHTML = purify(response);
            }
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            btnLoadMore.classList.remove("loading")

            if (loadMore && contentResult == "#result-magazines") {
                modalOpenPdfPageflip();
            }

            if( parseInt(btnLoadMore.getAttribute("data-page"))  > parseInt( btnLoadMore.getAttribute("data-total"))) {
                btnLoadMore.style.display = "none"
            }

            document.querySelectorAll(fieldset).forEach(function(el) {
                el.classList.remove("disabled")
            })
        });
    }

    if(btnLoadMore) {
        btnLoadMore.addEventListener("click", function() { search(true), btnLoadMore.dataset.page = parseInt(btnLoadMore.dataset.page) + 1 }, false );
    }

    document.querySelector(contentResult).addEventListener("submit", function(event) { event.preventDefault(), search(false), btnLoadMore.dataset.page = "1" }, false);
}

if (document.querySelector("#result-news-search")) {
    searchNoticiasSearch("[data-action=load-more]", "#result-news-search fieldset", "/buscar/ajax/news.html", "#result-news-search","#result-not-found-news" );
}

if (document.querySelector("#result-events")) {
    searchNoticiasSearch("[data-action=load-more-events]", "#result-events fieldset", "/buscar/ajax/events.html", "#result-events","#result-not-found-events" );
}

if (document.querySelector("#result-courses")) {
    searchNoticiasSearch("[data-action=load-more-coursers]", "#result-courses fieldset", "/buscar/ajax/courses.html", "#result-courses","#result-not-found-courses" );
}

if (document.querySelector("#result-courses-ead")) {
    searchNoticiasSearch("[data-action=load-more-coursers-ead]", "#result-courses-ead fieldset", "/buscar/ajax/courses-ead.html", "#result-courses-ead","#result-not-found-courses-ead" );
}

if (document.querySelector("#result-magazines")) {
    searchNoticiasSearch("[data-action=load-more-magazines]", "#result-magazines fieldset", "/buscar/ajax/magazines.html", "#result-magazines","#result-not-found-magazines" );
}

if (document.querySelector("#result-videos")) {
    searchNoticiasSearch("[data-action=load-more-videos]", "#result-videos fieldset", "/buscar/ajax/videos.html", "#result-videos","#result-not-found-videos" );
}

if (document.querySelector("#result-programs")) {
    searchNoticiasSearch("[data-action=load-more-programs]", "#result-programs fieldset", "/buscar/ajax/programas.html", "#result-programs","#result-not-found-programs" );
}

if (document.querySelector("#result-podcasts")) {
    searchNoticiasSearch("[data-action=load-more-podcasts]", "#result-podcasts fieldset", "/buscar/ajax/podcast.html", "#result-podcasts","#result-not-found-podcasts" );
}

if (document.querySelector("#result-articles")) {
    searchNoticiasSearch("[data-action=load-more-articles]", "#result-articles fieldset", "/buscar/ajax/articles.html", "#result-articles","#result-not-found-articles" );
}

if (document.querySelector("#result-notes")) {
    searchNoticiasSearch("[data-action=load-more-notes]", "#result-notes fieldset", "/buscar/ajax/notes.html", "#result-notes","#result-not-found-notes" );
}
